import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
const Portfolio = ({ classicHeader, darkTheme }) => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();

  const filters = {
    BUSINESS: "Business-Growth",
    
    APPLICATION: "Application-Development",
  };

  const projectsData = [
   
   
    
    {
      title: "Retail Program",
      projectInfo:
        "Generate an strategy in sales point to motivate the seller and shopper to buy for sika products",
      company: "Sika",
      attributes: "Analisys, Strategies, Psicology, Desing",
      industry: "Retail & Construction",
      date: "August 16, 2021",
      
      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
        linkedin: "http://www.linkedin.com/",
      },
      thumbImage: "images/projects/project-4.png",
      sliderImages: [
        
        "images/projects/project-4.png",
      ],
      categories: [filters.BUSINESS],
    },
    {
      title: "Strategy and Marketing",
      projectInfo:
        "Create a strategy to increase brand awareness and positioning to current a old clients that help to sales",
      company: "Nef Digital",
      attributes: "Marketing, Strategy,Analysys, Management, Engineer",
      industry: "Graphics & Advetising",
      date: "July 16, 2022",
      
      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
        linkedin: "http://www.linkedin.com/",
      },
      thumbImage: "images/projects/project-5.png",
      sliderImages: [
      
        "images/projects/project-5.png",
      ],
      categories: [filters.BUSINESS],
    },
    {
      title: "Wordpress Develop",
      projectInfo:
        "Wordpress development for a company website and listing of products",
      company: "Nefdigital",
      attributes: "PHP, CSS, HTML, CMS, BACKEND",
      industry: "Marketing & Graphic",
      date: "November 16, 2023",
      url: {
        name: "www.nefdigital.com",
        link: "https://www.nefdigital.com",
      },
      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
        linkedin: "http://www.linkedin.com/",
      },
      thumbImage: "images/projects/project-6.png",
      sliderImages: [
        "images/projects/project-11.png",
        
        
      ],
      categories: [filters.APPLICATION],
    },
    {
      title: "React Develop",
      projectInfo:
        "Software Production",
      company: "Nefdigital",
      attributes: "REACT, CSS, TYPESCRIPT,JAVASCRIPT, BACKEND, FRONTEND, SOCKETS, ROLES, USERS, AUTHENTICATION, INVENTORY MODULE, ORDERS MODULE, QUOTATION, GRAPHS AND MORE",
      industry: "MANUFACTURING",
      date: "June 16, 2026",
      urls: [
  {
    name: "Software Production",
    link: "https://staging.d3mo5fuapc6g0q.amplifyapp.com/",
  },
  {
    name: "Watch Demo Video",
    link: "https://youtu.be/mkQyIn_yOsE",
  },
],
      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
        linkedin: "http://www.linkedin.com/",
      },
      thumbImage: "images/projects/project-9.png",
      sliderImages: [
        "images/projects/project-12.png",
        "images/projects/project-13.png",
        "images/projects/project-14.png",
       

        
      ],
      categories: [filters.APPLICATION],
    },
   
    
    
    
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  return (
    <>
      <section
        id="portfolio"
        className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
      >
        <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
          {/* Heading */}
          <div className="position-relative d-flex text-center mb-5">
            <h2
              className={
                "text-24  text-uppercase fw-600 w-100 mb-0 " +
                (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
              }
            >
              Projects
            </h2>
            <p
              className={
                "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
                (darkTheme ? "text-white" : "text-dark")
              }
            >
              {" "}
              My Work
              <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
            </p>
          </div>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs justify-content-center border-bottom-0 mb-5 " +
              (darkTheme ? "nav-light" : "")
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " +
                    (filterKey === filters[oneKey] ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(filters[oneKey])}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio popup-ajax-gallery">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      project.categories.join(" ")
                    }
                    key={index}
                  >
                    <div className="portfolio-box rounded">
                      <div className="portfolio-img rounded">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div className="portfolio-overlay">
                          <a
                            className="popup-ajax stretched-link"
                            href=""
                            onClick={() => {
                              setSelectedProjectDetails(projectsData[index]);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                          />
                          <div className="portfolio-overlay-details">
                            <h5 className="text-white fw-400">
                              {project.title}
                            </h5>
                            {/*<span className="text-light">Category</span>*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      <div className="project-details-modal">
        {/* Modal */}
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          darkTheme={darkTheme}
        ></ProjectDetailsModal>
      </div>
    </>
  );
};

export default Portfolio;
